
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'4-1'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            여행 관리 - 여행타입 {{ $route.query.travel_type_ID === undefined ? '등록' : '수정' }}
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              {{ $route.query.travel_type_ID === undefined ? '등록' : '수정' }}
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_type_division'>여행타입구분<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="travel_type_division"
                v-model="formData.travelTypeDivision"
              >
                <option value='1'>국악와인열차</option>
                <option value='2'>팔도장터열차</option>
                <option value='3'>일반기차여행</option>
                <option value='4'>버스/자유여행</option>
                <option value='5'>섬/제주/해외여행</option>
              </select>
            </div>
          </div>
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_type_name'>여행타입명<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'travel_type_name'
                maxLength="50"
                placeholder = "여행타입명을 50자 내 입력해 주세요."
                v-model="formData.travelTypeName"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.travelTypeNameError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_type_status'>사용 여부<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="travel_type_status"
                v-model="formData.travelTypeStatus"
              >
                <option value='1'>사용</option>
                <option value='2'>미사용</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import {
  get_travel_type_one,
  insert_travel_type,
  update_travel_type
} from '../../ETC/Axios.vue'

export default {
  name: 'AdmintravelTypeManagementAdd',
  components: {
    AdminHeader,
    AdminFooter,
    Spiner

  },
  setup () {
    return {
      formData: ref({
        travelTypeDivision: '1',
        travelTypeName: '',
        travelTypeStatus: 1
      }),
      errorData: ref({
        travelTypeNameError: ''
      }),
      statusData: ref({
        spinnerStatus: false
      })
    }
  },
  methods: {
    check_form: function () {
      let continue_add = true
      if (this.formData.travelTypeName === '') {
        this.errorData.travelTypeNameError = '여행타입명을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.travelTypeNameError = ''
      }
      if (continue_add) {
        this.statusData.spinnerStatus = true
        if (this.$route.query.travel_type_ID === undefined) {
          insert_travel_type(
            this.formData.travelTypeDivision,
            this.formData.travelTypeName,
            this.formData.travelTypeStatus
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('등록이 완료되었습니다.')
            window.location.href = '/AdmintravelTypeManagement'
          })
        } else {
          update_travel_type(
            this.$route.query.travel_type_ID,
            this.formData.travelTypeDivision,
            this.formData.travelTypeName,
            this.formData.travelTypeStatus
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('수정이 완료되었습니다.')
            window.location.href = '/AdmintravelTypeManagement'
          })
        }
      } else {
        alert('필수 입력값을 확인해주세요.')
      }
    }
  },
  mounted () {
    if (this.$route.query.travel_type_ID !== undefined) {
      get_travel_type_one(this.$route.query.travel_type_ID).then((result) => {
        this.formData.travelTypeDivision = result[0].travel_type_division
        this.formData.travelTypeName = result[0].travel_type_name
        this.formData.travelTypeStatus = result[0].travel_type_status
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/TravelManagement/AdminTravelTypeManagementAdd.vue